import React, { useState, useEffect, useRef, useCallback } from 'react'
import HamburgerButton from './HamburgerButton'
import Overlay from './Overlay'
import useBodyScrollLock from '../../../hooks/useBodyScrollLock'

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const buttonRef = useRef(null)

  const handleToggle = useCallback(() => {
    setIsMenuOpen((prev) => !prev)
  }, [])

  const handleClose = useCallback(() => {
    setIsMenuOpen(false)
  }, [])

  useEffect(() => {
    if (!isMenuOpen) return

    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        setIsMenuOpen(false)
      }
    }

    document.addEventListener('keydown', handleEscape)
    return () => document.removeEventListener('keydown', handleEscape)
  }, [isMenuOpen])

  useBodyScrollLock(isMenuOpen)

  useEffect(() => {
    const main = document.querySelector('main')
    if (!main) return
    if (isMenuOpen) {
      main.inert = true
    } else {
      main.inert = false
    }
    return () => {
      main.inert = false
    }
  }, [isMenuOpen])

  return (
    <>
      <HamburgerButton
        ref={buttonRef}
        isOpen={isMenuOpen}
        onClick={handleToggle}
      />
      <Overlay
        isOpen={isMenuOpen}
        onClose={handleClose}
        buttonRef={buttonRef}
      />
    </>
  )
}

export default Navigation
